import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { ContactCategory }  from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "CONTACT_CATEGORY_LOADING" });
    },

    /**
     * Fetches the Contact Category List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await ContactCategory.getAll(params);
        data.sort  = params;
        dispatch({ type : "CONTACT_CATEGORY_LIST", data });
    },

    /**
     * Fetches a single Contact Category
     * @param {Function} dispatch
     * @param {Number}   contactCategoryID
     * @returns {Promise}
     */
    async fetchElem(dispatch, contactCategoryID) {
        const data = await ContactCategory.getOne({ contactCategoryID });
        dispatch({ type : "CONTACT_CATEGORY_ELEM", data });
        return data;
    },

    /**
     * Fetches the Contact Category Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await ContactCategory.getEditData();
        dispatch({ type : "CONTACT_CATEGORY_EDIT", data });
    },

    /**
     * Edits/Creates a Contact Category
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return ContactCategory.edit(data);
    },

    /**
     * Deletes the Contact Category
     * @param {Function} dispatch
     * @param {Number}   contactCategoryID
     * @returns {Promise}
     */
    deleteElem(dispatch, contactCategoryID) {
        return ContactCategory.delete({ contactCategoryID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "CONTACT_CATEGORY_LIST", "CONTACT_CATEGORY_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "CONTACT_CATEGORY_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "CONTACT_CATEGORY_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "CONTACT_CATEGORY_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            statuses  : action.data.statuses,
        };

    case "CONTACT_CATEGORY_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
